import { useEffect, useRef, useState } from 'react';
import PermissionGate from '../../../utils/PermissionGate';
import { alerta } from '../../../components/Alert';
import http from 'services/http';
import styles from './styles.module.css';

const naoMostrar = [
    'Milhar Brinde', 'Milhar Moto', 'Unidade',
    'Duque de Grupo', 'Terno de Grupo', 'Duque de Dezena', 'Duque de Dezena F.M.F',
    'Terno de Dezena', 'Terno de Dezena F.M.F', 'Passe', 'Passe vai e vem',
    'Milhar e Centena', 'Milhar Invertida', 'MC Invertida',
    'Centena Invertida'
];

const ordemModalidades = [
    'Milhar', 'Centena', 'Dezena', 'Grupo',
    'Duque de Dezena 1/2', 'Duque de Dezena 1/5',
    'Duque de Dezena F.M.F 1/2', 'Duque de Dezena F.M.F 1/5',
    'Duque de Grupo 1/2', 'Duque de Grupo 1/5',
    'Terno de Dezena 1/3', 'Terno de Dezena 1/5', 'Terno de Dezena 1/10',
    'Terno de Dezena F.M.F 1/3', 'Terno de Dezena F.M.F 1/5', 'Terno de Dezena F.M.F 1/10',
    'Terno de Grupo 1/3', 'Terno de Grupo 1/5', 'Terno de Grupo 1/10',
    'Passe 1/2', 'Passe 1/5', 'Passe vai e vem 1/2', 'Passe vai e vem 1/5'
];

const deveMostrar = (nome) => {
    if (naoMostrar.includes(nome)) return false;
    if (nome.toLowerCase().includes('combinado')) return false;
    return true;
};

const ordenarModalidades = (modalidades) =>
    [...modalidades].sort((a, b) => {
        const ia = ordemModalidades.indexOf(a.nome);
        const ib = ordemModalidades.indexOf(b.nome);
        return (ia === -1 ? 999 : ia) - (ib === -1 ? 999 : ib);
    });

const formatarValorExistente = (valor) => {
    if (valor === null || valor === undefined || valor === '') return '0,00';
    const num = parseFloat(String(valor).replace(',', '.'));
    return isNaN(num) ? '0,00' : num.toFixed(2).replace('.', ',');
};

const formatarValorMonetario = (valor) => {
    const digits = valor.replace(/\D/g, '');
    return (parseInt(digits || '0', 10) / 100).toFixed(2).replace('.', ',');
};

export default function ValoresDescarga() {
    const [modalidadesBanca, setModalidadesBanca] = useState([]);
    const [premiacao, setPremiacao] = useState('');
    const [cotacoes, setCotacoes] = useState([]);
    const [cotacaoSelecionada, setCotacaoSelecionada] = useState('');
    const [isActiveFildsEditDescarga, setIsActiveFildsEditDescarga] = useState(true);
    const [carregaPost, setCarregaPost] = useState(false);
    const [loading, setLoading] = useState(false);
    const containerDescargaLista = useRef();

    useEffect(() => {
        requestModalidadesBanca();
        requestCotacoes();
    }, []);

    async function requestModalidadesBanca() {
        try {
            setLoading(true);
            const response = await http.get('/bancas/modalidades');
            const { data: modalidades } = response.data;
            setModalidadesBanca(modalidades.map(mod => ({
                ...mod,
                descarga: formatarValorExistente(mod.descarga)
            })));
        } catch (error) {
            alerta(error.response?.data);
        } finally {
            setLoading(false);
        }
    }

    async function requestCotacoes() {
        try {
            const response = await http.get('bancas/titulo-cotacoes');
            const { data: cotacoesData } = response.data;
            setCotacoes(cotacoesData);
            if (cotacoesData.length > 0) setCotacaoSelecionada(cotacoesData[0].id);
        } catch (error) {
            console.log('Erro ao buscar cotações:', error);
        }
    }

    const extrairValoresCotacao = (nomeCotacao) => {
        if (!nomeCotacao) return { M: 0, C: 0, D: 0, G: 0 };
        const match = nomeCotacao.match(/M:\s*(\d+)\s*\/\s*C:\s*(\d+)\s*\/\s*D:\s*(\d+)\s*\/\s*G:\s*(\d+)/);
        return match
            ? { M: parseInt(match[1]), C: parseInt(match[2]), D: parseInt(match[3]), G: parseInt(match[4]) }
            : { M: 0, C: 0, D: 0, G: 0 };
    };

    const mapearModalidadeParaCotacao = (nome) => {
        const n = nome.toLowerCase();
        if (n.includes('milhar')) return 'M';
        if (n.includes('centena')) return 'C';
        if (n.includes('dezena')) return 'D';
        if (n.includes('grupo')) return 'G';
        return null;
    };

    function calcularDescarga() {
        if (!premiacao || !cotacaoSelecionada) {
            alerta({ error: true, message: 'Preencha a premiação e selecione uma cotação' });
            return;
        }
        const cotacao = cotacoes.find(c => c.id === parseInt(cotacaoSelecionada));
        if (!cotacao) return;

        const valores = extrairValoresCotacao(cotacao.nome);
        const premiacaoNum = parseFloat(premiacao.replace(',', '.'));
        if (isNaN(premiacaoNum) || premiacaoNum <= 0) {
            alerta({ error: true, message: 'Digite um valor válido para premiação' });
            return;
        }

        const arr = [...modalidadesBanca];
        arr.forEach((mod, idx) => {
            const tipo = mapearModalidadeParaCotacao(mod.nome);
            if (tipo && valores[tipo] > 0) {
                arr[idx].descarga = (Math.floor((premiacaoNum / valores[tipo]) * 100) / 100).toFixed(2).replace('.', ',');
            }
        });
        setModalidadesBanca(arr);
        setIsActiveFildsEditDescarga(false);
    }

    function handleChangeValueDescargaMonetario(event) {
        const { dataset: { index }, value } = event.target;
        const arr = [...modalidadesBanca];
        arr[index].descarga = formatarValorMonetario(value.replace(/[^0-9]/g, ''));
        setModalidadesBanca(arr);
    }

    async function salvarDescarga() {
        try {
            setCarregaPost(true);
            const res = await http.patch('/bancas/modalidades', { modalidades: modalidadesBanca });
            alerta(res.data);
        } catch (e) {
            alerta(e.response?.data);
        } finally {
            setCarregaPost(false);
        }
    }

    if (loading) return <div className="loader" />;

    return (
        <div className={styles.descarga}>
            <div className={styles.titlesecondTable}>
                <span>Valores da descarga</span>
            </div>

            <div style={{ display: 'flex', gap: '15px', alignItems: 'flex-end', padding: '15px', backgroundColor: '#f8f9fa', borderRadius: '8px', marginBottom: '15px', flexWrap: 'wrap' }}>
                <div style={{ display: 'flex', flexDirection: 'column' }}>
                    <label style={{ fontWeight: '500', marginBottom: '5px', fontSize: '14px' }}>Premiação (R$):</label>
                    <input
                        type="text"
                        inputMode="decimal"
                        className="form-control"
                        placeholder="0,00"
                        value={premiacao}
                        onChange={(e) => setPremiacao(formatarValorMonetario(e.target.value))}
                        style={{ width: '150px' }}
                    />
                </div>
                <div style={{ display: 'flex', flexDirection: 'column' }}>
                    <label style={{ fontWeight: '500', marginBottom: '5px', fontSize: '14px' }}>Cotação:</label>
                    <select
                        className="form-control"
                        value={cotacaoSelecionada}
                        onChange={(e) => setCotacaoSelecionada(e.target.value)}
                        style={{ minWidth: '250px' }}
                    >
                        <option value="">Selecione uma cotação</option>
                        {cotacoes.map(c => <option key={c.id} value={c.id}>{c.nome}</option>)}
                    </select>
                </div>
                <button className="btn btn-primary" onClick={calcularDescarga} style={{ height: '38px' }}>
                    Calcular
                </button>
            </div>

            <div className={styles.descargaLista} ref={containerDescargaLista}>
                {ordenarModalidades(modalidadesBanca.map((m, i) => ({ ...m, originalIndex: i })))
                    .filter(m => deveMostrar(m.nome))
                    .map(m => (
                        <div key={m.originalIndex}>
                            <label htmlFor={m.tipo}>{m.nome}</label>
                            <input
                                onChange={handleChangeValueDescargaMonetario}
                                disabled={isActiveFildsEditDescarga}
                                id={m.tipo}
                                data-index={m.originalIndex}
                                type="text"
                                inputMode="numeric"
                                className="form-control"
                                value={m.descarga}
                                placeholder="0,00"
                            />
                        </div>
                    ))}
            </div>

            <PermissionGate permissions={['Alterar modalidade']}>
                <div className={styles.descargaButton}>
                    {isActiveFildsEditDescarga ? (
                        <button className="btn btn-info" onClick={() => setIsActiveFildsEditDescarga(false)} disabled={carregaPost}>
                            Editar
                        </button>
                    ) : (
                        <button className="btn btn-secondary" onClick={() => setIsActiveFildsEditDescarga(true)} disabled={carregaPost}>
                            Desabilitar
                        </button>
                    )}
                    <button className="btn btn-success" onClick={salvarDescarga} disabled={carregaPost}>
                        Salvar
                    </button>
                </div>
            </PermissionGate>
        </div>
    );
}
